import { version } from '../../package.json';
export default version;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/version/index.js
// module id = 1893
// module chunks = 6